import { useQuery } from '@tanstack/react-query';
import { DownloadAppPlatform } from 'shared/types/download-app-platform';
import { getDownloadAppPlatform } from 'shared/utils/get-download-app-platform';

export const queryKey = 'download-app-platform';

export const useDownloadAppPlatformQuery = () =>
  useQuery<DownloadAppPlatform | null>({
    queryKey: [queryKey],
    queryFn: getDownloadAppPlatform,
  });
